import './FunnelChartReport.css';
import 'react-datepicker/dist/react-datepicker.css';
import { d3 } from 'react-d3-components';
import { t } from 'i18next';
import { connect } from 'react-redux';
import React from 'react';
import Loading from '../../loading/Loading';
import { stringToNumberLocale, stringToPercentage } from '../../../helpers/formatter';
import FilterPanel, { date_range } from '../../filters/filterPanel/FilterPanel';

const TOTAL_BAR_HEIGHT = 400;

const FunnelChartReport = ({
  title, data, leftTimerange, rightTimerange, extraInfo, leftTotal, rightTotal, totalLabel, disabled,
}) => {
  if (
    leftTotal === undefined || rightTotal === undefined
    || data.left.some(e => e.value === undefined)
    || data.right.some(e => e.value === undefined)
  ) { return <Loading size={60} />; }
  const leftUnused = data.left.reduce((count, { value }) => count - (Number.isNaN(Number(value))
    ? 0 : Number(value)), 100) / 100;
  const rightUnused = data.right.reduce((count, { value }) => count - (Number.isNaN(Number(value))
    ? 0 : Number(value)), 100) / 100;
  const colorRange = ['#4A91E2', '#92C3D8'].concat(d3.scale.category20().range().slice(0).splice(0, 2));

  return (
    <div className="FunnelChartReport report">
      <h2>{t(title)}</h2>
      <br />
      <div className="dateRanges">
        <div className="dateRangeLeft">
          <FilterPanel name="left"
            disabled={disabled}
            className="leftFunnelDateRange"
            currentFilters={leftTimerange}
            filters={[
              date_range,
            ]}
            applyFilters={false}
          />

        </div>
        <div className="dateRangeRight">
          <FilterPanel name="right"
            disabled={disabled}
            className="rightFunnelDateRange"
            currentFilters={rightTimerange}
            filters={[
              date_range,
            ]}
            applyFilters={false}
          />
        </div>
      </div>
      <div className="funnel">
        <div className="left">
          <div className="bar"
            style={{
              backgroundColor: colorRange[data.left.length],
              height: TOTAL_BAR_HEIGHT * leftUnused,
            }}
            key={totalLabel}
          >
            <label className={`${leftTotal === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
              {(leftTotal === t('unableToFetchData'))
                ? t('unableToFetchData')
                : (stringToNumberLocale(leftTotal) + ' ' + totalLabel)}
            </label>
          </div>
          {data.left.map(({ key, value }, index) => (
            <div className="bar"
              style={{
                backgroundColor: colorRange[index],
                height: Number.isNaN(Number(value)) ? 0 : Number(value) / 100 * TOTAL_BAR_HEIGHT,
              }}
              key={key}
            >
              <label className={`${value === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
                {value === t('unableToFetchData')
                  ? t('unableToFetchData')
                  : Number.isNaN(parseFloat(value))
                    ? t('N/A')
                    : stringToPercentage(value) + ' ' + key}
              </label>
            </div>
          ))}
        </div>

        <div className="right">
          <div className="bar"
            style={{
              backgroundColor: colorRange[data.right.length],
              height: TOTAL_BAR_HEIGHT * rightUnused,
            }}
            key={totalLabel}
          >
            <label className={`${rightTotal === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
              {(rightTotal === t('unableToFetchData'))
                ? t('unableToFetchData')
                : (stringToNumberLocale(rightTotal) + ' ' + totalLabel)}
            </label>
          </div>
          {data.right.map(({ key, value }, index) => (
            <div className="bar"
              style={{
                backgroundColor: colorRange[index],
                height: Number.isNaN(Number(value)) ? 0 : Number(value) / 100 * TOTAL_BAR_HEIGHT,
              }}
              key={key}
            >
              <label className={`${value === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
                {value === t('unableToFetchData')
                  ? t('unableToFetchData')
                  : Number.isNaN(parseFloat(value))
                    ? t('N/A')
                    : stringToPercentage(value) + ' ' + key}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div className="extraData">
        {' '}
        {extraInfo.map(({
          key, left, right,
        }) => (
          <div key={key}>
            <div>
              <span>{t(`axis.${key}`)}</span>
              <br />
              <span className={`${left === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
                {(left === t('unableToFetchData'))
                ? t('unableToFetchData')
                : Number.isNaN(parseFloat(left))
                  ? t('N/A')
                  : left}
              </span>
            </div>
            <div className="filler" />
            <div>
              <span>{t(`axis.${key}`)}</span>
              <br />
              <span className={`${right === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
                {(right === t('unableToFetchData'))
                ? t('unableToFetchData')
                : Number.isNaN(parseFloat(right))
                  ? t('N/A')
                  : right}
              </span>
            </div>
          </div>
        ))}

      </div>

    </div>
  );
};

export default connect()(FunnelChartReport);
